import { Typography } from "@mui/material";
import RiskFactorsContent, {
  RiskFactorsContentProps,
} from "~/components/vulnerabilities/risk-factors-content";
import { ReportsNoItemsSection } from "../../components";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";

type DataType = "cve" | "advisory" | "check" | "checks" | "security";

const getContent = (dataType: DataType) => {
  const CONTENT_BY_DATA_TYPE: Record<DataType, string> & { default: string } = {
    cve: "When Mondoo evaluates the security of an asset, it considers context: Factors like defensive measures or running database servers can lower or raise the risk to your business if the asset were compromised. The list below shows the risk factors for this asset. Red indicates factors that raise the asset's risk rating. Blue indicates factors that lower the asset's risk rating.",

    advisory:
      "When Mondoo evaluates advisories, it considers context: Factors like running services or defensive measures on the asset can raise or lower the actual risk that an advisory poses. The list below shows the risk factors for this advisory. Red indicates factors that raise the asset's risk rating. Blue indicates factors that lower the asset's risk rating.",

    security:
      "When Mondoo evaluates security, it considers context: Factors like defensive measures or exposed credentials can lower or raise the actual risk that a misconfiguration poses. The list below shows the factors Mondoo found in this space that affect risk. Red indicates factors that raise the asset's risk rating. Blue indicates factors that lower the asset's risk rating.",

    check:
      "When Mondoo runs checks against security policies, it considers context: Factors like running services or defensive measures on the asset can raise or lower the actual risk that a failed check poses. The list below shows the risk factors for the assets that failed this check. Red indicates factors that raise the asset's risk rating. Blue indicates factors that lower the asset's risk rating.",

    checks:
      "When Mondoo evaluates security, it considers context: Factors like defensive measures or exposed credentials can lower or raise the actual risk that a misconfiguration poses. The list below shows the factors Mondoo found in this space that affect risk. Red indicates factors that raise the asset's risk rating. Blue indicates factors that lower the asset's risk rating.",

    default:
      "When Mondoo evaluates the security of an asset, it considers context: Factors like defensive measures or running database servers can lower or raise the risk to your business if the asset were compromised. The list below shows the risk factors for this asset. Red indicates factors that raise the asset's risk rating. Blue indicates factors that lower the asset's risk rating.",
  };

  return CONTENT_BY_DATA_TYPE[dataType] ?? CONTENT_BY_DATA_TYPE.default;
};

interface RiskFactorsProps {
  dataType: DataType;
  riskFactors: RiskFactorsContentProps["riskFactors"];
}

export function AssetReportRiskFactors({
  dataType,
  riskFactors,
}: RiskFactorsProps) {
  const content = getContent(dataType);

  return (
    <>
      <ReportsSectionHeading heading="Risk factors" />
      {!riskFactors ? (
        <ReportsNoItemsSection target="Risk Factors" />
      ) : (
        <>
          <Typography sx={{ mb: 2 }}>{content}</Typography>
          <RiskFactorsContent riskFactors={riskFactors} twoColumn />
        </>
      )}
    </>
  );
}
